"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { FUSportsMatch } from "fansunited-data-layer";
import { TeamLogo } from "@/components/ui/TeamLogo";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { cn } from "@/utilities/core/cn";
interface MatchCompetitionInfoProps {
  match: Pick<FUSportsMatch, "competition" | "round" | "group">;
  className?: string;
}
export function MatchCompetitionInfo(t0) {
  const $ = _c(14);
  const {
    match,
    className
  } = t0;
  const labels = useLabels();
  const competition = match.competition;
  if (!competition?.name) {
    return null;
  }
  const round = match.round;
  let roundLabel = null;
  if (round?.type === "LEAGUE" && round.name) {
    roundLabel = `${labels.matches.round} ${round.name}`;
  } else {
    if (match.group?.name) {
      roundLabel = match.group.name;
    } else {
      if (round?.name) {
        roundLabel = round.name;
      }
    }
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center justify-center gap-2 text-xs", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== competition.assets || $[3] !== competition.id) {
    t2 = competition.assets?.logo && <TeamLogo src={competition.assets.logo} kind="competition" size="xs" alt="" competitionId={competition.id} />;
    $[2] = competition.assets;
    $[3] = competition.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== competition.name) {
    t3 = <span>{competition.name}</span>;
    $[5] = competition.name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== roundLabel) {
    t4 = roundLabel && <><span className="opacity-50">•</span><span>{roundLabel}</span></>;
    $[7] = roundLabel;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}